import { Model, NeoModel } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import RawGenericTransactionLookup from '../Models/Lookups/RawGenericTransactionLookup';
import UpdateTransactionCommand from '../Models/Commands/UpdateTransactionCommand';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticEventLookup from '../../EventMapping/Models/StaticEventSearchModal/StaticEventLookup';

@NeoModel
export default class UpdateCashTransactionComponentVM extends Views.ViewModelBase {

    constructor(
        public instrumentApiCient = AppService.get(Types.ApiClients.InstrumentApiClient),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService),
        public taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
        this.updateCashTransactionCommand = new UpdateTransactionCommand();
        this.updateCashTransactionCommand.transactionType = 2;
    }

    public updateCashTransactionCommand: UpdateTransactionCommand;
    public selectedCashTransactions: RawGenericTransactionLookup[] = [];

    public events: Model.PlainObject<StaticEventLookup>[] = [];
    public filteredEvents: Model.PlainObject<StaticEventLookup>[] = [];

    public clearInputs() { 
        this.updateCashTransactionCommand.newStaticEventID = null;
    }
}